import { GET_SEARCH_NODE } from './index'

export const requestSearchNode = (payload) => ({
    type: GET_SEARCH_NODE.REQUEST,
    payload,
})